module.exports = __webpack_public_path__ + "img/RotatedBrake.31c1bc90.png";